import React, { useState } from 'react';

import { Button, Stack } from '@mui/material';

import { FRAUD_STATUS, PATCH_UPDATE_FRAUD_STATUS } from '~/consts/order';

import { updateOrder } from '~/services/OrdersService';

interface Props {
  order: App.Order;
  onOrderUpdated?: (updatedOrder: App.Order) => void;
}

const FLAGGED_STATUSES: Array<App.FraudStatus> = [
  FRAUD_STATUS.MANUAL_FLAGGED_FOR_REVIEW,
  FRAUD_STATUS.AUTO_FLAGGED_FOR_REVIEW,
];

const FRAUD_STATUSES: Array<App.FraudStatus> = [FRAUD_STATUS.MANUAL_REVIEWED_FRAUD, FRAUD_STATUS.AUTO_REVIEWED_FRAUD];

const NOT_FRAUD_STATUSES: Array<App.FraudStatus> = [
  FRAUD_STATUS.MANUAL_REVIEWED_NOT_FRAUD,
  FRAUD_STATUS.AUTO_REVIEWED_NOT_FRAUD,
];

export function MarkOrderFraud({ order, onOrderUpdated }: Props) {
  const [updatingStatus, setUpdatingStatus] = useState<App.FraudStatus | null>(null);

  const fraudStatus = order.fraud_status;
  const isFlagged = FLAGGED_STATUSES.includes(fraudStatus);
  const isFraud = FRAUD_STATUSES.includes(fraudStatus);
  const isNotFraud = NOT_FRAUD_STATUSES.includes(fraudStatus);

  const showFraudButton = isFlagged || isNotFraud || (!isFraud && !isFlagged);
  const showNotFraudButton = isFlagged || isFraud;
  const notFraudLabel = isFraud ? 'Unmark order as fraud' : 'Mark order as not fraud';

  const updateFraudStatus = async (fraudStatus: App.FraudStatus) => {
    setUpdatingStatus(fraudStatus);
    const fraudPayload = {
      op: PATCH_UPDATE_FRAUD_STATUS,
      fraudStatus,
    };

    try {
      await updateOrder(order.id, fraudPayload);

      const updatedOrder = {
        ...order,
        fraud_status: fraudStatus,
      };

      onOrderUpdated?.(updatedOrder);
    } finally {
      setUpdatingStatus(null);
    }
  };

  const isUpdating = (fraudStatus: App.FraudStatus) => updatingStatus === fraudStatus;

  return (
    <Stack direction="column" spacing={1} alignItems="flex-start" sx={{ mt: 1, ml: 1 }}>
      {showFraudButton && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => updateFraudStatus(FRAUD_STATUS.MANUAL_REVIEWED_FRAUD)}
          disabled={Boolean(updatingStatus) || order.fraud_status === FRAUD_STATUS.MANUAL_REVIEWED_FRAUD}
        >
          {isUpdating(FRAUD_STATUS.MANUAL_REVIEWED_FRAUD) ? 'Updating...' : 'Mark order as fraud'}
        </Button>
      )}
      {showNotFraudButton && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => updateFraudStatus(FRAUD_STATUS.MANUAL_REVIEWED_NOT_FRAUD)}
          disabled={Boolean(updatingStatus) || order.fraud_status === FRAUD_STATUS.MANUAL_REVIEWED_NOT_FRAUD}
        >
          {isUpdating(FRAUD_STATUS.MANUAL_REVIEWED_NOT_FRAUD) ? 'Updating...' : notFraudLabel}
        </Button>
      )}
    </Stack>
  );
}
